import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <div className="container">
        <Link to="/" className="back-link">← Back to StudioIQ</Link>
        
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p>The Jeweler's Shop LLC dba StudioIQ</p>
        </div>

        <div className="effective-date">
          <strong>Effective Date:</strong> December 16, 2024
        </div>

        <div className="legal-content">
          <h2>1. Information We Collect</h2>
          
          <h3>Account Information</h3>
          <p>When you create a StudioIQ account, we collect:</p>
          <ul>
            <li>Name and email address</li>
            <li>Company name and business information</li>
            <li>Payment information (processed securely by third-party processors)</li>
            <li>Account preferences and settings</li>
          </ul>

          <h3>Usage Information</h3>
          <p>We automatically collect information about how you use StudioIQ:</p>
          <ul>
            <li>Repair quotes generated and pricing data</li>
            <li>Feature usage and application interactions</li>
            <li>Device information, IP address, and browser type</li>
            <li>Log files and analytics data</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain the StudioIQ service</li>
            <li>Process payments and manage subscriptions</li>
            <li>Improve our software and develop new features</li>
            <li>Provide customer support and technical assistance</li>
            <li>Send important account and service updates</li>
            <li>Comply with legal obligations and prevent fraud</li>
          </ul>

          <h2>3. Information Sharing</h2>
          <p>We do not sell, trade, or rent your personal information. We may share information only in these limited circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> Trusted third parties who help us operate StudioIQ (payment processors, hosting providers, analytics)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
            <li><strong>Your Consent:</strong> When you explicitly agree to share information</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>We implement industry-standard security measures to protect your information:</p>
          <ul>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular security audits and updates</li>
            <li>Access controls and authentication requirements</li>
            <li>Secure data centers and backup systems</li>
          </ul>

          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access, update, or delete your personal information</li>
            <li>Export your data in a portable format</li>
            <li>Opt out of non-essential communications</li>
            <li>Request clarification about our data practices</li>
          </ul>

          <h2>6. Data Retention</h2>
          <p>We retain your information only as long as necessary to provide services and comply with legal obligations. Account data is typically retained for the duration of your subscription plus 90 days, unless longer retention is required by law.</p>

          <h2>7. International Users</h2>
          <p>StudioIQ is operated from the United States. If you are accessing our service from outside the US, please be aware that your information may be transferred to and processed in the United States.</p>

          <h2>8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by email or through the StudioIQ application.</p>

          <div className="contact-info">
            <h4>Contact Us</h4>
            <p>If you have questions about this Privacy Policy, please contact us:</p>
            <p><strong>The Jeweler's Shop LLC dba StudioIQ</strong><br/>
            Email: privacy@studioiq.com<br/>
            Address: Florida, United States</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;